import Component from "./PuppyLeafParty";
export default Component;
